import type { FC } from "react";

export const NoMatch: FC = () => <div />;
